import {
  downloadAnalyticsExport,
  type AnalyticsExportFormat,
  type AnalyticsExportTableSection,
} from "@/components/pages/analytics/front-desk/utils/analyticsFileExport";
import type { GuesteriaPartnerDetail } from "./guesteriaPartnersModel";

type PartnerDetailExportParams = {
  partner: GuesteriaPartnerDetail;
  hotelId: string;
  /** Task 0038 — a filename-safe slug (e.g. the from/to range), not the old named period enum. */
  period: string;
  periodLabel: string;
  connectionStatusLabel: string;
  categoryText: string;
  regionText: string;
  earningsSummary: string;
  currency: string;
  points: Array<{
    label: string;
    totalRevenue: number;
    booked: number;
    totalOrders: number;
    currency: string;
  }>;
};

function buildPartnerDetailSections(
  params: PartnerDetailExportParams,
): AnalyticsExportTableSection[] {
  const {
    partner,
    hotelId,
    periodLabel,
    connectionStatusLabel,
    categoryText,
    regionText,

    earningsSummary,
    currency,
    points,
  } = params;

  return [
    {
      title: "Partner",
      headers: ["Field", "Value"],
      rows: [
        ["Partner", partner.name],
        ["Partner ID", partner.id],
        ["Hotel ID", hotelId],
        ["Period", periodLabel],
        ["Connection Status", connectionStatusLabel],
        ["Category", categoryText],
        ["Region", regionText],
        ["Earnings (summary)", earningsSummary],
      ],
    },
    {
      title: "Revenue Analytics",
      headers: [
        "Period",
        `Revenue (commission, ${currency})`,
        `Booked (${currency})`,
        "Orders",
      ],
      rows: points.map((point) => [
        point.label,
        point.totalRevenue,
        point.booked,
        point.totalOrders,
      ]),
    },
  ];
}

export function downloadPartnerDetailExport(
  format: AnalyticsExportFormat,
  params: PartnerDetailExportParams,
): void {
  downloadAnalyticsExport(
    format,
    buildPartnerDetailSections(params),
    `partner-${params.partner.id}-${params.period}`,
  );
}
